import { lazy } from 'react';

const AprrovedProducerCertificationConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
		
	},
	routes: [
		{
			path: '/producer/consult/transfer',
			component: lazy(() => import('./AprrovedCertificationContainer'))
		}
	]
};

export default AprrovedProducerCertificationConfig;

